
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/en/legal/account-terms",
      function () {
        return require("private-next-pages/en/legal/account-terms.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/en/legal/account-terms"])
      });
    }
  